var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom",style:({backgroundColor: _vm.$themeTokens.surface})},[_c('div',{staticClass:"inner-bottom",style:(_vm.innerStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }